import React, { useState } from "react";
import { Modal, Button } from '@prosolve/common-components-ui'
import useDataTrainers from "../../../../dataHooks/useDataTrainers";
import { getClientSubdomain } from "../../../../utils";

export default ({
  trainer = {},
  onClose,
  onSuccess,
}) => {
  const {
    updateTrainer,
    deleteTrainer,
  } = useDataTrainers()

  const [isBusy, setIsBusy] = useState(false);

  const clientSubdomain = getClientSubdomain()
    
  const isStarSubdomain = (clientSubdomain === 'star')

  const onClickSubmit = async () => {
    if (!isBusy) {
      setIsBusy(true)

      try {
        if (isStarSubdomain) {
          trainer.trainerRequestStatus = 'Removed by Admin'
          await updateTrainer(trainer)
        } else {
          await deleteTrainer(trainer)
        }

        setIsBusy(false)

        onSuccess()
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Confirm'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Delete Trainer'} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        {'Are you sure you wish to delete this trainer?'}
      </div>
    </Modal>
  )
}